/*

sohel 09/27/2022 2700453848 Trigger Group -> Trigger group Client and Agency Type Changes
sohel 09/29/2022 2700453848 Trigger Group ->Added Toast, validation and Event Trigger Changes
sohel 10/12/2022 2700453848 Triggers, Trigger Group -> Added breadcrumbs, label changes, pagination changes
sohel 10/14/2022 2700453848 Trigger Group -> Added Comments.
sohel 10/17/2022 2700453848 Trigger and Trigger Group fixed validation issue, added tooltip and label changes
Prakash 10/31/2022 2700453848 Added class for text-fields and Buttons.
Sohel 11/02/2022 2699761741 pass props
Sohel 11/03/2022 2699761741 pass event type value
Sohel 11/14/2022 2699761741 disabled mode field
Sohel 11/19/2022 2699761741 Enable Mode field
Prakash 11/21/2022 2699761741 Removed extra Padding.
Prakash 11/22/2022 2699761741 Added conditional card for spacing.
Akhila 11/23/2022 2699761741 Added Status TextField And Changed All Field Variant in TextField
Suresh Peddavoora 11/28/2022 2699761741 Fixed Responsive issues for Tab Resolution
kavyareddy 12/26/2022 2699761741 Removed validation for triggerCode in searchForm
manikanta 01/03/2022 2700430604 save  and close functionality added to  popup
manikanta 01/04/2022 2699761741 batch triggers save and close functionality
manikanta 01/04/2022 2699761741 fixed  event triggers popup  disable option
Ashraf 01/04/2022 2699761741 fixed event triggers reset issue
Dilip 01/06/2023 2699761741 removed mode field
Raghu 02/27/2023 2699761741 added new class and fixed alignments
Prakash 08/05/2023 2699761741 add theming classname.
sohel 12/11/2023 2699761741  Added validation for TriggerCode and Trigger Description in Triggers Maintenance
*/

import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import SearchEventTacticTable from '../SearchEventTactics/SearchEventTacticTable';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const SearchEventTactics = ({
  setSelectedEventTrigger,
  selectedEventTrigger,
  isEventTriggerGroup,
  eventType,
  cardSpace,
  setSearchEventTactics,
  searchEventTactics,
  handleEventTacticSearch,
  tacticValue,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState({});
  const [saveData, setSaveData] = useState(selectedEventTrigger ? selectedEventTrigger : []);
  const StatusOptions = [{key: 'N', value: 'Completed'}];

  // set search data(2700486402)
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  // form initial values(2700486402)
  const initialValues = {
    code: '',
    description: '',
    mode: '',
    isDraft: {key: 'N', value: 'Completed'},
  };

  // form field valiation(2700486402)

  // reset form data(2700486402)
  const onClear = () => {
    const data = {
      code: '',
      description: '',
      mode: '',
      isDraft: {key: 'N', value: 'Completed'},
    };
    setSearchData(data);
  };

  return (
    <div className={cardSpace ? '' : ''}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {touched, errors, values, handleChange, resetForm, handleBlur, setFieldValue} =
            props;
          return (
            <div className={`standard-field-textfields new-standard-textfields`}>
              <Form autoComplete="off" noValidate>
                <ErrorBoundaryForComponents>
                  <Grid container spacing={2}>
                    <Grid item xs={6} md={3} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName}`}
                        placeholder={`Enter Trigger Name`}
                        label="Trigger Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="code"
                        value={values?.code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText>{touched.code && errors.code && errors.code} </FormHelperText>
                    </Grid>
                    <Grid item xs={6} md={6} className="form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        name="description"
                        placeholder={`Enter Trigger Description`}
                        label="Trigger Description"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} md={3} xl={3} className="form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="isDraft"
                        id="isDraft"
                        size="small"
                        options={StatusOptions}
                        disabled
                        required
                        value={values.isDraft}
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('isDraft', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                  </Grid>
                  <div className="form-row form-group">
                    <div className="col-md-7 col-lg-7">
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="outlined"
                          className={`reset-btn mr-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            setSubmit(true);
                            resetForm();
                            onClear();
                            !selectedEventTrigger?.length > 0 && setSaveData && setSaveData([]);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                    <div className="col-md-5 col-lg-5">
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="text"
                          className={`reset-btn ml-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            //  handleEventTacticSearch(),
                            setSearchEventTactics && setSearchEventTactics(false);
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="outlined"
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            setSelectedEventTrigger(saveData);
                            setSearchEventTactics && setSearchEventTactics(false);
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
      <SearchEventTacticTable
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        setSelectedEventTrigger={setSelectedEventTrigger}
        selectedEventTrigger={selectedEventTrigger}
        isEventTriggerGroup={isEventTriggerGroup}
        eventType={eventType}
        saveData={saveData}
        setSaveData={setSaveData}
      />
    </div>
  );
};
export default SearchEventTactics;
